import { SecondaryButton } from 'components';

export default function ExportPdfButton({ open, setOpen, privatized }) {
	return !open ? (
		<SecondaryButton onClick={() => setOpen(true)}>
			{privatized ? 'Request Export' : 'Export'}
		</SecondaryButton>
	) : null;
}
